<div fxLayout="column" style="height: 250px;">
    <div fxLayout="column" fxLayoutAlign="start"
         style="height:70px; width:100%;  background-color: var(--primary); color: white; padding:15px;">
        <mat-card-title style="font-size:14px; font-family: 'Century Gothic', 'Helvetica Neue', sans-serif">{{affirmation.title}}</mat-card-title>
        <mat-card-subtitle style="font-size:12px; color: white;">Προθεσμία Υποβολής: &nbsp;<span
                style="font-size:12px; font-weight: 900; color: white;">{{affirmation.hasDeadline ? affirmation.deadline_date : '-'}}</span>
        </mat-card-subtitle>

    </div>

    <div class="content" #affirmationContent>{{affirmation.subtitle}}</div>
    <div fxLayoutAlign="start center center" class="footer">
        <button (click)="completeAffirmation()" mat-flat-button style="color: var(--secondaryBlue);" >Συμπλήρωση δήλωσης</button>
    </div>
</div>
